import { Injectable } from '@angular/core';
import { type NavigationExtras, type Params, Router } from "@angular/router";
import { Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class NavigationControlFacade {
  constructor(protected store: Store,
                     protected router: Router) {
  }

  //<editor-fold desc="Selectors">

  slugs$ = this.store.select(FlatStates.NavigationControlState.slugs$);
  currentUrl$ = this.store.select(FlatStates.NavigationControlState.currentUrl$);
  elearningUrl$ = this.store.select(FlatStates.NavigationControlState.elearningUrl$);
  subjectUrl$ = this.store.select(FlatStates.NavigationControlState.subjectUrl$);
  isPrinting$ = this.store.select(FlatStates.NavigationControlState.isPrinting$);
  showSearch$ = this.store.select(FlatStates.NavigationControlState.showSearch$);
  showClose$ = this.store.select(FlatStates.NavigationControlState.showClose$);
  queryParams$ = this.store.select(FlatStates.NavigationControlState.queryParams$);

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestNavigate(path: any[],
                  queryParams?: Params,
                  extras?: NavigationExtras) {
    return this.store.dispatch(new Navigate(path, queryParams, extras));
  }
  
  requestNavigateToLogin() {
	  return this.store.dispatch(new Navigate(['/login']));
  }

  //</editor-fold>
}
